import styled from "styled-components";
import {
  cancelResponsiveHorizontalInset,
  responsiveWidth,
} from "responsive";

export const Wrapper = styled.div`
  ${responsiveWidth}
  ${cancelResponsiveHorizontalInset}
  width: 100%;
  padding-top: 24px;

  @media (max-width: 768px) {
    padding-top: 16px;
  }
`;

export const Title = styled.h1`
  text-align: left;
  color: #0d0d0d;
  margin: 0 0 16px;
  font-family: "SpoqaHanSansNeo-Regular", "Apple SD Gothic Neo", sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.05em;

  @media (max-width: 767px) {
    font-size: 20px;
  }
`;

export const Divider = styled.hr`
  border: none;
  border-bottom: 1px solid #e8e8e8;
  margin: 0 0 24px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;
